import { useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';

export interface GuideStyle {
  backgroundColor: string;
  border: string;
  borderRadius?: string;
  typography: {
    fontSize: string;
    fontWeight: number;
    textAlign?: string;
    color: string;
  };
}

export const useGuideStyles = () => {
  const theme = useTheme();

  return {
    primary: {
      backgroundColor: alpha(theme.palette.primary.main, 0.1),
      border: `1px solid ${theme.palette.primary.main}4d`, // 0.3 opacity
      typography: {
        fontSize: '24px',
        fontWeight: 700,
        textAlign: 'center',
        color: theme.palette.primary.main,
      },
    },
    secondary: {
      backgroundColor: alpha(theme.palette.secondary.main, 0.1),
      border: `1px solid ${theme.palette.secondary.main}4d`,
      typography: {
        fontSize: '16px',
        fontWeight: 500,
        textAlign: 'center',
        color: theme.palette.secondary.main,
      },
    },
    description: {
      backgroundColor: alpha(theme.palette.secondary.main, 0.05),
      border: `1px solid ${theme.palette.secondary.main}4d`,
      typography: {
        fontSize: '14px',
        fontWeight: 400,
        color: theme.palette.text.secondary,
      },
    },
    media: {
      backgroundColor: alpha(theme.palette.info.main, 0.1),
      border: `1px solid ${theme.palette.info.main}4d`,
      typography: {
        fontSize: '14px',
        fontWeight: 500,
        color: theme.palette.info.main,
      },
    },
    background: {
      backgroundColor: alpha(theme.palette.grey[800], 0.1),
      border: `1px solid ${theme.palette.info.main}4d`,
      borderRadius: '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: 'auto',
      typography: {
        fontSize: '14px',
        fontWeight: 500,
        color: theme.palette.info.main,
      },
    },
  } as const;
};

// 영역 타입별 스타일 매핑을 위한 Hook
export const useAreaTypeStyles = () => {
  const styles = useGuideStyles();

  return {
    mainText: styles.primary,
    subText: styles.secondary,
    media: styles.media,
  } as const;
};
